/**
 * Resolve API base URL before services.jsx reads window.API_BASE_URL.
 * Priority: explicit window override → Vite env → host heuristics (legacy).
 *
 * Env must win over host heuristics: a stage build hosted on manage*.tezus.com.br
 * would otherwise force window.location.origin and ignore VITE_API_BASE_URL.
 */
export function applyApiBaseUrl() {
  if (window.API_BASE_URL) return;

  // Empty string is intentional same-origin (stage/dev behind proxy).
  const fromEnv = import.meta.env.VITE_API_BASE_URL;
  if (typeof fromEnv === 'string') {
    window.API_BASE_URL = fromEnv;
    return;
  }

  const host = window.location.hostname;

  if (host === 'manage.localhost' || host.startsWith('manage')) {
    window.API_BASE_URL = window.location.origin;
    return;
  }

  if (['localhost', '127.0.0.1'].includes(host)) {
    // Empty → same-origin; Vite proxies /api → manage (see vite.config.js)
    window.API_BASE_URL = '';
    return;
  }

  window.API_BASE_URL = 'https://manage1.tezus.com.br';
}
